import { useEffect } from "react"
import { Projeto } from "src/components/projetos/types"
import { InputText } from "src/framework/components/forms/inputs/InputText"

interface JustificativaValorServicoProps {
  formState: Projeto
  setFormState: (newState: Partial<Projeto>) => void
  error?: boolean
}

export const JustificativaValorServico = ({ formState, setFormState, error = false }: JustificativaValorServicoProps) => {
  return (
    <InputText
      error={error}
      fullWidth
      value={formState.justificativa_valor_servico || ""}
      onChange={(e: any) => {
        // Remove caracteres especiais
        const caracterEspecialRegex = /[^a-zA-Z0-9\s]/g
        e.target.value = e.target.value.replace(caracterEspecialRegex, '')

        // Verifica se o valor é somente espaços em branco
        const somenteEspacos = !/\S/.test(e.target.value)
        if (somenteEspacos) e.target.value = ""

        // Atualiza o estado do formulário
        setFormState({ justificativa_valor_servico: e.target.value || "" })
      }}
      label="Justificativa"
      maxLength={400}
      placeholder="Informe o motivo de estar adicionando um valor menor que o valor mínimo"
      className="input-justificativa-servico"
    />
  );
}